export default "__VITE_ASSET__31c939fe__"